import { useParams } from "react-router-dom";

export function useProjectContext() {
    const { projectId } = useParams();

    const isValidProjectId = projectId && projectId.trim() !== "";

    return {
        projectId: isValidProjectId ? projectId : null,
        isValidProjectId
    };
}
